<template>
  <b-row class="margin-0">
    <b-col cols="12" class="padding-0 margin-bottom-16">
      <Alert variant="light-warning" :text="$lang.changeAssessmentPlanAlert" />
    </b-col>
    <b-col
      cols="12"
      class="padding-0 font-size-12 color-complementary-300 margin-bottom-16"
    >
      <div>
        {{ $lang.template }}:
        <span class="font-weight-bold">
          {{ pathOr("", ["template", "caption"], item) }}
        </span>
      </div>
      <div>
        {{ $lang.oldAssessmentPlan }}:
        <span class="font-weight-bold">
          {{ pathOr("", ["assessment_plan", "name"], item) }}
        </span>
      </div>
    </b-col>
    <b-col cols="12">
      <Teleport to="body">
        <Dropdown
          :title="$lang.newAssessmentPlan"
          :label="$lang.newAssessmentPlan"
          :placeholder="$lang.newAssessmentPlan"
          :value="form.newAssessmentPlan"
          name="newAssessmentPlan"
          id="newAssessmentPlan"
          :vuelidateObj="$v.form.newAssessmentPlan"
          :asyncSearch="getAssessmentPlanOptions"
          :insideFeature="true"
          @input="input"
          @focus="resetValidation"
          @blur="checkValidation"
        />
      </Teleport>
    </b-col>
    <b-col cols="12" class="padding-0 flex-end">
      <Button
        contentClass="justify-content-center"
        variant="filled-complementary"
        :text="$lang.cancel"
        @click="handleClose"
      />
      <Button
        class="margin-right-8"
        contentClass="justify-content-center"
        variant="filled-primary"
        :text="$lang.submit"
        :loading="loading"
        @click="submitChangeAssessmentPlan"
      />
    </b-col>
  </b-row>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import { Alert } from "@/components/re-design";
import { Dropdown, Button } from "@/components/re-design/forms";
import { required } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import { generateError, toastAlert } from "@/shared/utils";
import { getAssessmentPlanCombo } from "@/services";
import { setAssessmentPlan } from "@/modules/kanoon/services";
import Teleport from "vue2-teleport";

export default {
  mixins: [inputMixin],
  components: { Alert, Dropdown, Button },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  validations() {
    return {
      form: {
        newAssessmentPlan: { required },
      },
    };
  },
  data() {
    return {
      form: {
        newAssessmentPlan: null,
      },
      loading: false,
    };
  },
  methods: {
    pathOr,
    handleClose() {
      this.$emit("handleClose");
    },
    async getAssessmentPlanOptions(text = null) {
      try {
        const templateId = pathOr(null, ["template", "id"], this.item);
        const response = await getAssessmentPlanCombo(templateId, text);
        const { options } = response;
        return options;
      } catch (error) {
        generateError(error);
      }
    },
    async submitChangeAssessmentPlan() {
      this.$v.$touch();
      if (this.$v.$anyError) return;

      try {
        this.loading = true;
        const centerExecuteCode = pathOr(null, ["code"], this.item);
        const assessmentPlanId = pathOr(
          null,
          ["newAssessmentPlan", "id"],
          this.form
        );
        const response = await setAssessmentPlan(
          centerExecuteCode,
          assessmentPlanId
        );
        const { message } = response;
        toastAlert(message);
        this.handleClose();
        this.$emit("reloadList");
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
